import {useCallback} from 'react';

import {type ThunkResult} from '../../../types/redux';
import {useDispatch} from '../../hooks';
import {type Ref as DiscussionCommentRef} from './types';

export function useDiscussionCommentRefThunk<
  RefType extends DiscussionCommentRef,
  ArgType extends any[],
  ThunkType extends ThunkResult<any>,
>(ref: RefType | null, fn: (ref: RefType, ...fnArgs: ArgType) => ThunkType) {
  const dispatch = useDispatch();
  return useCallback(
    (...args: ArgType) => (ref != null ? dispatch(fn(ref, ...args)) : void 0),
    [dispatch, ref, fn]
  );
}
